export default __webpack_public_path__ + "img/perfil.19e39f0e.png";